import { Email } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useCallback, useState } from "react";
import { useRecoilValue } from "recoil";
import { messagesState } from "../../../recoil";
import { Message, NewMessage, MessageList } from "./components";

const TabMessages = () => {

    // Use Recoil
    const messages = useRecoilValue(messagesState);

    // Use State
    const [showNewMessage, setShowNewMessage] = useState<boolean>(false);

    // Use Callback
    const handleClickNewMessage = useCallback(() => {
        setShowNewMessage(true)
    }, []);
    const handleCloseNewMessage = useCallback(() => {
        setShowNewMessage(false);
    }, []);

    return (
        <Stack rowGap={2}>
            <Stack direction="row" justifyContent="end">
                <Button
                    variant="outlined"
                    onClick={handleClickNewMessage}
                    disabled={showNewMessage}
                    startIcon={<Email />}
                >
                    New Message
                </Button>
            </Stack>
            <NewMessage
                show={showNewMessage}
                onClose={handleCloseNewMessage}
            />
            <MessageList isShowingNewMessage={showNewMessage} />
        </Stack>
    );
};

export default TabMessages;